module.exports = __webpack_public_path__ + "res/ic_menu_campaigns_s.b498d5013687f6ecc2a02e49d75af693.png";